import { render, staticRenderFns } from "./clientslbs.vue?vue&type=template&id=880c1dba"
import script from "./clientslbs.vue?vue&type=script&lang=js"
export * from "./clientslbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports